// extracted by mini-css-extract-plugin
var _1 = "ProcessedInvestmentsStyle-module__avatar___Pi6Af";
var _2 = "ProcessedInvestmentsStyle-module__drag-right___PPwzi";
var _3 = "ProcessedInvestmentsStyle-module__drag-right___PPwzi";
var _4 = "ProcessedInvestmentsStyle-module__main___Yl2tV";
var _5 = "ProcessedInvestmentsStyle-module__pitch-link___ST9Cs";
var _6 = "ProcessedInvestmentsStyle-module__pitch-link___ST9Cs";
var _7 = "ProcessedInvestmentsStyle-module__zebra-table-container___G6I4s";
var _8 = "ProcessedInvestmentsStyle-module__zebra-table-item___Zp1G3";
var _9 = "ProcessedInvestmentsStyle-module__zebra-table-item-first___sEnkl";
var _a = "ProcessedInvestmentsStyle-module__zebra-table-item-last___v6aSe";
var _b = "ProcessedInvestmentsStyle-module__zebra-table-row___DoTDR";
var _c = "ProcessedInvestmentsStyle-module__zebra-table-container___G6I4s";
var _d = "ProcessedInvestmentsStyle-module__zebra-table-item___Zp1G3";
var _e = "ProcessedInvestmentsStyle-module__zebra-table-item-first___sEnkl";
var _f = "ProcessedInvestmentsStyle-module__zebra-table-item-last___v6aSe";
var _10 = "ProcessedInvestmentsStyle-module__zebra-table-row___DoTDR";
export { _1 as "avatar", _2 as "drag-right", _3 as "dragRight", _4 as "main", _5 as "pitch-link", _6 as "pitchLink", _7 as "zebra-table-container", _8 as "zebra-table-item", _9 as "zebra-table-item-first", _a as "zebra-table-item-last", _b as "zebra-table-row", _c as "zebraTableContainer", _d as "zebraTableItem", _e as "zebraTableItemFirst", _f as "zebraTableItemLast", _10 as "zebraTableRow" }
